import './Login.css'
import React from 'react'
import { connect } from 'react-redux'
import { setUser } from '../../ducks/Auth'
import { db, auth } from '../../services/firebase'
import { default as LoginForm } from '../../forms/LoginForm'
import NotificationSystem from 'react-notification-system'
import logo_enele from '../../assets/img/logo-enele.png'
import { style as NotifyStyle } from '../../variables/Variables.jsx'

class Login extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            _notificationSystem: null
        }
    }

    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem })
    }

    render() {
        return (
            <div className="login__container">
                <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
                <div className="login__form">
                    <div className="login__logo-container">
                        <img className="login__logo" src={logo_enele} alt="react-logo" />
                    </div>
                    <LoginForm loading={this.state.loading} onSubmit={this._handleSubmit} />
                </div>
            </div>
        )
    }

    _handleSubmit = values => {
        this.setState({ loading: true })
        const { email, password } = values
        auth.signInWithEmailAndPassword(email, password)
            .then(user => this._validateUser(user))
            .catch(e => this._handleFirebaseErrorCode(e.code))
    }

    _validateUser = user => {
        db.collection('users').doc(user.uid).get()
            .then(userSnapshot => {
                userSnapshot.exists
                    ? this._validateRole({
                        ...userSnapshot.data(),
                        id: user.uid,
                        refreshToken: user.refreshToken
                    })
                    : this._throwError('Este usuário não existe.')
            })
            .catch(e => {
                console.log(e)
                this._throwError('Não foi possível localizar este usuário.')
            })
    }

    _validateRole = userObject => {
        db.collection('roles').doc(userObject.role).get()
            .then(role => {
                role.exists
                    ? this._setUser({ ...userObject, roleName: role.data().name })
                    : this._throwError('O nível de acesso selecionado não existe.')
            })
            .catch(e => this._throwError('Erro ao definir nível de acesso.'))
    }

    _setUser = userObject => {
        this.props.setUser(userObject)
        this.setState({ loading: false })
    }

    _throwError = message => {
        this.notify(message, 'error')
        this.setState({ loading: false })
    }

    _handleFirebaseErrorCode = code => {
        this.setState({ loading: false })
        switch (code) {
            case 'auth/user-not-found':
                return this.notify('Este usuário não existe', 'error')
            case 'auth/invalid-email':
                return this.notify('Email inválido', 'error')
            case 'auth/wrong-password':
                return this.notify('Senha incorreta', 'error')
            case 'auth/user-disabled':
                return this.notify('Seu usuário foi desativado pela Enele', 'error')
            case 'auth/network-request-failed':
                return this.notify('Você está sem internet. Verifique sua conexão', 'error')
            default:
                return this.notify('Erro ao autenticar', 'error')
        }
    }

    notify = (message, level) => {
        this.state._notificationSystem.addNotification({
            title: null,
            message: (<b>{message}</b>),
            level,
            position: 'tr',
            autoDismiss: 4
        })
    }
}

export default connect(null, { setUser })(Login)



// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx